import React, {useState, FormEvent} from 'react';
import Modal from 'shared/components/modal';
import RadioButtons from 'shared/components/radio-buttons';
import {useDispatch, useSelector} from 'react-redux';
import {closeModal} from 'shared/actions/modal';
import {updateUser} from 'shared/portfolio/actions/student';
import {Store} from 'src/types/store';

export const CITIZENSHIP_MODAL = 'CITIZENSHIP_MODAL';

const CitizenshipModal = () => {
  const dispatch = useDispatch();
  const show = useSelector((state: Store) => state.modal[CITIZENSHIP_MODAL] || false);

  const [isUsCitizenOrResident, setIsUsCitizenOrResident] = useState<string>('');

  const closeCitizenshipModal = () => {
    dispatch(closeModal(CITIZENSHIP_MODAL));
  };

  const onSaveCitizenship = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(updateUser({isUsCitizenOrResident})).then(closeCitizenshipModal);
  };

  return (
    <Modal show={show} onClose={closeCitizenshipModal}>
      <form onSubmit={onSaveCitizenship}>
        <Modal.TextHeader onClose={closeCitizenshipModal}>Add Your Citizenship</Modal.TextHeader>
        <Modal.Body>
          <RadioButtons
            value={isUsCitizenOrResident}
            onChange={(e) => setIsUsCitizenOrResident(e.target.value)}
            options={[
              {value: 'true', label: 'Yes'},
              {value: 'false', label: 'No'},
            ]}
            legendText="Are you a US citizen or permanent resident?"
          />
        </Modal.Body>
        <Modal.Footer
          primaryButton={{
            text: 'Save',
            type: 'submit',
          }}
          secondaryButton={{
            text: 'Cancel',
            onClick: closeCitizenshipModal,
            rightAligned: true,
          }}
        />
      </form>
    </Modal>
  );
};

export default CitizenshipModal;
